import { Label } from "../Form/Form";
import { Switch as SwitchRAC, SwitchProps } from "react-aria-components";

type Props = SwitchProps & {
  label?: string | React.ReactNode;
};

export default function Switch({ label, ...props }: Props) {
  return (
    <SwitchRAC
      className="group flex gap-2 items-center disabled:text-grey-4"
      {...props}
    >
      {label && <Label className="m-0">{label}</Label>}
      <div className="flex h-[30px] w-[52px] shrink-0 cursor-pointer rounded-full bg-clip-padding border-2 border-solid border-tangerine/50 p-[3px] box-border transition duration-200 ease-in-out bg-transparent group-pressed:bg-tangerine group-selected:bg-tangerine group-disabled:bg-grey-4 outline-hidden group-focus-visible:ring-2 ring-black">
        <span className="h-[22px] w-[22px] transform rounded-full bg-white border-2 border-black/30 group-selected:border-white transition duration-200 ease-in-out translate-x-0 group-selected:translate-x-[100%]" />
      </div>
    </SwitchRAC>
  );
}
